export const getDeployedRegionFromUrl = (url: string): string | undefined => {
    // url format: https://ui.uat.uae.wls.brighterion.io
    const urlTokens = url.split('.');
    const deployedRegionIndex = urlTokens.indexOf('wls') - 1;

    if (deployedRegionIndex < 0) {
        return undefined;
    }

    return urlTokens[deployedRegionIndex];
};

export enum EventNames {
    pageView = 'Page View',
    click = 'Click',
    trackUser = 'trackUser'
}

export const enabledAnalytics = (): boolean => {
    const isProd = process.env.NODE_ENV === 'production';
    return typeof ((window as unknown) as CustomWindow).connect !== 'undefined' && isProd;
};

export const trackEventClickEvent = ({ clickIdentifier, text }: ClickEventTrack) => {
    if (enabledAnalytics()) {
        /** Check if analytics is enabled */
        if (((window as unknown) as CustomWindow).connect.analytics.getIsEnabled()) {
            ((window as unknown) as CustomWindow).connect.analytics.track(EventNames.click, {
                'Click Identifier': clickIdentifier,
                Text: text
            });
        }
    }
};

export const registerAnalyticsPayload = (user: User, target: string) => {
    if (enabledAnalytics()) {
        ((window as unknown) as CustomWindow).connect.analytics?.register({
            deployedRegion: getDeployedRegionFromUrl(window.location.href),
            customerId: user.customerId,
            environment: process.env.NODE_ENV || 'development',
            tenantKey: user.tenantKey,
            target
        });
    }
};
